import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { PossibleFilterValue } from "@/services/cloudchipr.api";

interface InfrastructureArchitectureRegionSelectLabelProps {
  option: PossibleFilterValue;
}

export const InfrastructureArchitectureRegionSelectLabel: FC<
  InfrastructureArchitectureRegionSelectLabelProps
> = ({ option }) => {
  return (
    <Stack>
      <Typography variant="body2">{option.title}</Typography>
      <Typography variant="caption" color="text.secondary" lineHeight={1.25}>
        {option.value}
      </Typography>
    </Stack>
  );
};
